import { get } from 'lodash';
import moment from 'moment';

const TS_FORMAT = 'MMM DD HH:mm';

// round off to nearest day or hour
export const getEndTime = (arg= 'day') => {
  if ( arg === 'hour') {
    return moment().startOf('hour').format();
  }
  return moment().subtract(1, 'day').endOf('day').format();
}

export const getDisplayInterval = (duration) => {
  const to = moment(getEndTime('hour'));
  const from = moment(to).subtract(duration, 'days');

  return {
    from: from.format(TS_FORMAT),
    to: to.format(TS_FORMAT)
  }
}

export const getInsightsWithCauseText = (insights, aiAlertsDimensionMapping) => {
  return insights.map((insight) => {
    const values = insight.values.map((value) => {
      const { cause, dimension } = value;
      let causeTxt = cause;

      if (`${cause}`.toLowerCase() === 'unknown') {
        const dimensionDisplay = get(aiAlertsDimensionMapping, [dimension, 'pulse5Label'], dimension);
        causeTxt = `${cause} (${dimensionDisplay})`;
      }

      return { ...value, causeTxt };
    });

    return { ...insight, values };
  });
}
